import React from 'react';
import { Info } from 'lucide-react';

interface ConversionInfoProps {
  tokenToWeiRate: number;
  minWithdrawal: string;
  networkFee: string;
  gasFeeEstimate: string;
}

export function ConversionInfo({ tokenToWeiRate, minWithdrawal, networkFee, gasFeeEstimate }: ConversionInfoProps) {
  return (
    <div className="bg-gray-800/50 rounded-lg p-4 border border-gray-700">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
        <Info size={20} className="text-blue-400" />
        Conversion Rates & Fees
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <h4 className="text-sm font-medium text-gray-400 mb-2">Token to WEI</h4>
          <p className="text-white">
            {tokenToWeiRate} Tokens = 1 WEI
          </p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-gray-400 mb-2">WEI to ETH</h4>
          <p className="text-white">
            10<sup>18</sup> WEI = 1 ETH
          </p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-gray-400 mb-2">Minimum Withdrawal</h4>
          <p className="text-white">
            {minWithdrawal} ETH
          </p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-gray-400 mb-2">Network Fee</h4>
          <p className="text-white">
            ${networkFee} + {gasFeeEstimate} ETH (Gas)
          </p>
        </div>
      </div>
    </div>
  );
}